import React, { useEffect, useState } from 'react';

/**
 * Karte mit dem Beratungsbüro in Gifhorn.
 *
 * Leaflet wiegt rund 40 KB gzip und wird nur auf /kontakt gebraucht — deshalb
 * lädt es erst, wenn die Seite im Browser steht. Der Rahmen mit fester Höhe
 * ist von Anfang an da, damit nichts springt.
 *
 * Warum erst nach dem Hydrieren (`useEffect`) und nicht `React.lazy` direkt im
 * Baum: Die Seite ist vorgerendert, und eine Suspense-Grenze ohne Marker im HTML
 * lässt das Hydrieren scheitern. So ist der erste Render im Browser derselbe wie
 * im Prerendering (leerer Rahmen); das Bauskript entfernt die Karte aus dem HTML
 * (`scripts/prerender.js`), weil Leaflet sie erst nach dem Rendern aufbaut.
 */
const OfficeMapInner = React.lazy(() => import('./OfficeMapInner'));

const OfficeMap: React.FC = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);

  return (
    <div
      style={{
        borderRadius: 'var(--r)',
        overflow: 'hidden',
        border: '1px solid var(--line)',
        height: 262,
        background: 'var(--green-tint)',
      }}
    >
      {ready && (
        <React.Suspense fallback={null}>
          <OfficeMapInner />
        </React.Suspense>
      )}
    </div>
  );
};

export default OfficeMap;
